import { Button, Typography } from "@suraasa/placebo-ui"
import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { API } from "@/api"
import { APIQueries } from "@/api/queries"
import FullPageLoading from "@/components/full-page-loading"
import { useAuth } from "@/context/auth-context"
import { redirectToLogout, removeAuthInfo } from "@/lib/auth"
import routes, { routeBuilder } from "@/lib/routes"

import ErrorPage from "./error-page"

const OrgBootstrap = () => {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()

  const params = {
    type: "club",
  }

  const orgListQuery = useQuery({
    queryKey: APIQueries.organization.list(params).queryKey,
    queryFn: () =>
      API.organization.list({
        params: params,
      }),
    enabled: isAuthenticated,
  })

  useEffect(() => {
    if (!isAuthenticated) return

    if (orgListQuery.isSuccess) {
      const firstOrg = orgListQuery.data?.[0]

      if (firstOrg?.id) {
        navigate(
          routeBuilder(routes.dashboard.base, {
            clubId: firstOrg.id.toString(),
          }),
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, orgListQuery.isSuccess])

  if (!isAuthenticated || orgListQuery.isLoading) {
    return <FullPageLoading />
  }

  const handleLogout = () => {
    removeAuthInfo()
    redirectToLogout()
  }

  if (orgListQuery.isSuccess && orgListQuery.data?.length === 0) {
    return (
      <ErrorPage
        render={() => (
          <div className="flex flex-col items-center justify-center gap-3 px-4 text-center">
            <Typography variant="title2" className="text-onSurface-900">
              You don't have access to this platform
            </Typography>

            <Typography className="max-w-md text-[14px] text-onSurface-600">
              Please try signing in with a different account or contact your
              administrator for access.
            </Typography>

            <Button className="mt-2" color="black" onClick={handleLogout}>
              Sign out
            </Button>
          </div>
        )}
      />
    )
  }

  return null
}

export default OrgBootstrap
